<div class="form form--place-of-birth form--full-width" [ngClass]="getLevelClass()">
  <div class="form__label">
    <basic-label [noIndent]="true"></basic-label>
  </div>

  <div class="form__inline-field-container form__inline-field-container--two-fields">
    <div class="form__field">
      <text-autocomplete-dropdown
        [propertyName]="countryPropertyName"
        [placeholder]="getPlaceholder(0) || 'Country'"
        (valueChanged)="countryChangedTrigger($event)"
      ></text-autocomplete-dropdown>
    </div>
    <div class="form__field">
      <text-autocomplete-dropdown
        [propertyName]="statePropertyName"
        [placeholder]="getPlaceholder(1) || 'State'"
        [style.visibility]="showStateField ? 'visible' : 'hidden'"
        [useValuesFromProperty]="true"
        #stateRef
      ></text-autocomplete-dropdown>
    </div>
  </div>
</div>
